import { FacadeElement } from "../panels/common";
import { FacadeElementType } from "../panels/facadeElementType";

export class ViewerZoomingService {
    constructor(
        private viewer: Autodesk.Viewing.Viewer3D,
        private model: Autodesk.Viewing.Model,
    ) {}

    /**
     * Zooms to a panel and selects it in the viewer
     * @param panel The panel to zoom to
     */
    zoomToPanel(panel: FacadeElement): void {
        this.fitToView(panel);

        this.viewer.select([panel.panelDbId], this.model);
    }

    private fitToView(panel: FacadeElement) {
        panel.getWorldOrigin(tempFacadeElementOrigin);

        if (panel.elementType === FacadeElementType.StandardPanel
            || panel.elementType === FacadeElementType.CustomPanel) {
            panel.getWorldNormal(tempFacadeElementNormal);
        } else {
            tempFacadeElementNormal.set(0, 0, 0);

            const leftWingWallCoordinateSystem = panel.getLeftWingWallCoordinateSystem();
            const rightWingWallCoordinateSystem = panel.getRightWingWallCoordinateSystem();

            if (leftWingWallCoordinateSystem && rightWingWallCoordinateSystem) {
                tempVector.setFromMatrixColumn(2, leftWingWallCoordinateSystem);
                tempFacadeElementNormal.add(tempVector);

                tempVector.setFromMatrixColumn(2, rightWingWallCoordinateSystem);
                tempFacadeElementNormal.add(tempVector);
            }

            if (panel.elementType === FacadeElementType.CustomZShaped) {
                tempVector.setFromMatrixColumn(2, panel.getShelfCoordinateSystem());
                tempFacadeElementNormal.add(tempVector);
            }
        }

        tempVector.copy(tempFacadeElementOrigin).add(tempFacadeElementNormal.normalize());

        this.viewer.navigation.setView(tempVector, tempFacadeElementOrigin);
        this.viewer.navigation.orientCameraUp(true);

        this.viewer.fitToView([panel.panelDbId], this.model);
    }
}

const tempFacadeElementOrigin = new THREE.Vector3();
const tempFacadeElementNormal = new THREE.Vector3();
const tempVector = new THREE.Vector3();
